import React from 'react';
import s from './FormTitle.module.css';

export function FormTitle({ title, subtitle }) {
    return (
        <div className={s.formTitle}>
            <div className={s.title}>{title}</div>
            {subtitle && <p className={s.subtitle}>{subtitle}</p>}
        </div>
    );
}
